import { BaseModel } from "@/models/base.model"
import { type IInstructionFeedbackActivityType } from "@/interfaces/api/instruction-feedback-activity-type.interface"

export class InstructionFeedbackActivityType
  extends BaseModel
  implements IInstructionFeedbackActivityType
{
  public static className = "InstructionFeedbackActivityType"

  public static verboseName = "Terugkoppelingsactiviteittype"

  name: string
  systemKey: string | null

  constructor(type: IInstructionFeedbackActivityType) {
    super(type)

    this.name = type.name
    this.systemKey = type.systemKey ?? null
  }
}
